// A LISTA-ELVÁLASZTÓ VONAL — halvány kártya-szegély-szín (`--table-hairline`), két oldalt pár px-szel BELJEBB
// húzva (pszeudó-elem, `inset-x-3`), hogy ne érjen a kártya széléig (rendszer-konvenció: a táblák és a kártya-
// listák így választják el a sorokat). A hívó elemének `relative`-nek kell lennie — a konstans ezt is tartalmazza.

/** Vonal a sor ALJÁN; az utolsó sor alatt nincs (a kártya alja zárja). */
export const HAIRLINE_ROW =
  "relative after:pointer-events-none after:absolute after:inset-x-3 after:bottom-0 after:h-px after:bg-[color:var(--table-hairline)] after:content-[''] last:after:hidden";

/** Vonal az elem ALJÁN mindig (pl. egy kártya-fejléc alatt). */
export const HAIRLINE_BOTTOM =
  "relative after:pointer-events-none after:absolute after:inset-x-3 after:bottom-0 after:h-px after:bg-[color:var(--table-hairline)] after:content-['']";

/** Vonal az elem TETEJÉN (pl. egy lista utáni lábléc fölött). */
export const HAIRLINE_TOP =
  "relative before:pointer-events-none before:absolute before:inset-x-3 before:top-0 before:h-px before:bg-[color:var(--table-hairline)] before:content-['']";
